export const ANSWER_MAX_COUNT = 10;

export const QUESTION_TYPES = [
    {type: "single", name: "Один или несколько вариантов"},
    {type: "ordering", name: "Установление порядка"},
    {type: "matching", name: "Установление пар"},
];

// Локальный стабильный ключ для ответов без id (ещё не сохранённых на бэкенде).
// AnswerRow - stateful компонент (своя useState для модалки кропа), а ключ
// массива по индексу (key={ind}) при добавлении/удалении строк заставляет React
// переиспользовать чужой DOM-инстанс с чужим внутренним состоянием - отсюда баг
// "нельзя загрузить картинку в 3-й вариант" (см. QA 2026-07-25: React путает,
// какой строке принадлежит открытая модалка кропа). answerKey() ниже - stable id.
let localKeySeq = 0;
export const nextLocalKey = () => `local_${Date.now()}_${localKeySeq++}`;
export const answerKey = (answer) => answer.id ?? answer._localKey;

export const initialAnswers = (type) => {
    if (type === "ordering") return [{text: "", _localKey: nextLocalKey()}, {text: "", _localKey: nextLocalKey()}];
    if (type === "matching") {
        return [
            {text: "", pair_item: "", _localKey: nextLocalKey()},
            {text: "", pair_item: "", _localKey: nextLocalKey()},
        ];
    }
    return [
        {correct: false, text: "", _localKey: nextLocalKey()},
        {correct: false, text: "", _localKey: nextLocalKey()},
    ];
};

// Ответ -> payload для create_answers/change_answers. sort_order фиксирует порядок
// (важно для ordering) и позицию пары для остальных типов. Картинка (миниатюра +
// полный размер) - опциональный довесок, доступный только у "Один или несколько
// вариантов" (2026-07-26: на ordering/matching картинку откатили).
export const answerPayload = (type, answer, sortOrder) => {
    if (type === "ordering") {
        return {text: answer.text, correct: true, sort_order: sortOrder};
    }
    if (type === "matching") {
        return {text: answer.text, pair_item: answer.pair_item, correct: true, sort_order: sortOrder};
    }
    // img_question/img_question_full - только когда явно очищены (removeImage
    // ставит "", а не undefined/null) - иначе PATCH ничего про них не знает и не
    // трогает уже сохранённую картинку (partial update), что и нужно, когда
    // учитель просто не касался картинки этого ответа.
    const image = {
        ...(answer.img_question_base64 ? {img_question_base64: answer.img_question_base64} : {}),
        ...(answer.img_question_full_base64 ? {img_question_full_base64: answer.img_question_full_base64} : {}),
        ...(answer.img_question === "" ? {img_question: ""} : {}),
        ...(answer.img_question_full === "" ? {img_question_full: ""} : {}),
    };
    return {text: answer.text, correct: !!answer.correct, sort_order: sortOrder, ...image};
};

export const hasImage = (a) => !!(a.img_question || a.img_question_base64);

// Картинка на "Один или несколько вариантов" работает по принципу "всё или ничего":
// раз учитель добавил картинку хотя бы одному варианту, у остальных она тоже
// становится обязательной - иначе часть вариантов с картинкой, часть без выглядит
// как незаконченная работа для ученика. Текст обязателен всегда, вне зависимости
// от картинок (2026-07-26 - раньше картинка могла заменить текст, теперь нет).
export const questionImageRequired = (question) =>
    (question.type || "single") === "single" && (question.answers || []).some(hasImage);

// Возвращает ключ ошибки или null, если вопрос валиден.
// ordering/matching картинок не показывают вообще, текст там всегда обязателен, как раньше.
export const validateQuestion = (question) => {
    const {type, answers} = question;
    if (type === "matching") {
        if (answers.some((a) => !a.text || !a.pair_item)) return "missing_text";
        return null;
    }
    if (type === "ordering") {
        if (answers.some((a) => !a.text)) return "missing_text";
        return null;
    }
    if (answers.some((a) => !a.text)) return "missing_text";
    if (questionImageRequired(question) && answers.some((a) => !hasImage(a))) return "missing_image";
    if (!answers.some((a) => a.correct)) return "no_correct";
    return null;
};
